export const state = () => ({
  bootstrap: null,
  showBottomSection: true,
  cart_unique_id: null,
  recentlyViewedProducts: [],
  recentlyViewedPostsId: [],
})
